import auth from './auth';

function fetch(input, init) {
    const accessToken = auth.getAccessToken();
    init = init || {};
    init.headers = init.headers || {};
    if (accessToken) {
        init.headers.Authorization = `Bearer ${accessToken}`;
    }
    init.headers['Accept'] = 'application/json';
    return window.fetch(input, init)
        .then((resp) => {
            if (resp.status === 401) {
                if (!window.sessionStorage.getItem('state')) {
                    window.sessionStorage.setItem('state', Math.random().toString());
                }
                if (!window.sessionStorage.getItem('nonce')) {
                    window.sessionStorage.setItem('nonce', Math.random().toString());
                }

                const domain = auth.getDomain();
                const url = `https://${domain}/authorize?` +
                    `response_type=${encodeURIComponent('token')}&` +
                    `client_id=dental.ddx.smartbrush&` +
                    `redirect_uri=${encodeURIComponent(`https://${window.location.hostname}/auth/callback?redirect_uri=${window.location.pathname}${window.location.search}`)}&` +
                    `scope=${encodeURIComponent('openid profile practice.patient.read order.read order.write')}&` +
                    `state=${encodeURIComponent(window.sessionStorage.getItem('state'))}&` +
                    `nonce=${encodeURIComponent(window.sessionStorage.getItem('nonce'))}`;
                window.sessionStorage.setItem('authorize_url', url);
                window.location = `${url}&prompt=none`;
                return;
            }
            if (resp.status === 405) {
                window.location = `https://${window.location.hostname}/mfg/subscribe`;
                return;
            }
            return resp;
        });
}

export default fetch;
